import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Button } from "./button";

interface Props {
  children: React.ReactNode;
  moduleName?: string;
}

interface State {
  hasError: boolean;
  errorMessage: string;
}

export class ModuleErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, errorMessage: error.message };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error(
      `[ErrorBoundary][${this.props.moduleName ?? "unknown"}]`,
      error,
      info.componentStack
    );
  }

  private handleReset = (): void => {
    this.setState({ hasError: false, errorMessage: "" });
  };

  render(): React.ReactNode {
    if (!this.state.hasError) return this.props.children;

    return (
      <div className="flex flex-col items-center justify-center min-h-[200px] gap-4 p-6 rounded-xl bg-white/[0.03] border border-white/[0.08]">
        <RefreshCw className="w-8 h-8 text-white/30" />
        <div className="text-center">
          <p className="text-white/80 font-medium">
            {this.props.moduleName
              ? `${this.props.moduleName} wymaga odświeżenia`
              : "Odśwież żeby kontynuować"}
          </p>
          <p className="text-white/40 text-sm mt-1">
            Ten moduł potrzebuje odświeżenia — kliknij poniżej lub naciśnij F5
          </p>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={this.handleReset}
          className="border-white/[0.12] text-white/60 hover:bg-white/[0.06]"
        >
          <RefreshCw className="w-4 h-4 mr-2" />
          Załaduj ponownie
        </Button>
      </div>
    );
  }
}
